// TableBody.tsx
import { cn } from "@utils/cn";
import { HTMLAttributes } from "react";

export const TableBody = ({
    className,
    ...props
}: HTMLAttributes<HTMLTableSectionElement>) => (
    <tbody className={cn('', className)} {...props} />
);
